export const formatXResponseData = (res_es_0, res_es_1) => {
    const user_lists = [];

    const userES0 = res_es_0.data.data.user_lists[0];
    if (res_es_0.data.data.user_lists.length !== 0) {
        user_lists.push({
            id: userES0.id,
            name: userES0.name,
            username: userES0.username,
            verification_status: userES0.verified,
            profile_url: userES0.profile_image_url,
        });
    }

    if (res_es_1.data.data.user_lists.length !== 0) {
        const users = res_es_1.data.data.user_lists;
        users.forEach((user) => {
            if (user.post_author.user_id && user.post_author.user_id !== null && user.post_author.user_id !== userES0.id)
                user_lists.push({
                    id: user.post_author.user_id,
                    name: user.post_author.name,
                    username: user.post_author.username,
                    verification_status: user.post_author.is_verified === 1,
                    profile_url: user.post_author.media[0].url,
                });
        });
    }

    return user_lists;
};
